import React from 'react';
import Spinner from "./layout/Spinner";
import ErrorMessage from "./components/ErrorMessage";
import {ROOT_PATH} from "./index";
import {ConfigurationStore} from "./context/ConfigurationContext";

interface MainInterface {}

declare global {
    interface Window {
        sergenConf: Object;
    }
}


const Main: React.FC<MainInterface> = (props) => {
    const [configuration, setConfiguration] = React.useState(undefined as (undefined | any));
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [fulfilled, setFulfilled] = React.useState(false);
    let component = <></>;

    const loadConf = async () => {
        const res = await fetch(`${ROOT_PATH}/config/config.json`);
        if (!res.ok) {
            throw new Error();
        }

        const conf = await res.json();

        return conf;
    };

    React.useEffect(() => {
        setLoading(true);
        setError(false);
        setFulfilled(false);
        loadConf().then(res => {
            setFulfilled(true);
            setLoading(false);
            setConfiguration(res);
            window['sergenConf'] = res;
        }).catch(err => {
            setError(true);
            setLoading(false);
        })
    },[]);

    if (error) {
        component = <ErrorMessage kind={'error'} message={"Caricamento Configurazione dell'applicazione"}/>;
    }

    if (fulfilled) {
        component = <ConfigurationStore conf={configuration}>{props.children}</ConfigurationStore>;
    }

    if (loading) {
        component = <Spinner/>;
    }

    return (
        <>{component}</>
    )

};

export default Main;